import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  CircularProgress,
} from "@mui/material";

const DeleteConfirmDialog = ({ open, onClose, onConfirm, deleting, ticketData }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: "#ffffff",
        },
      }}
    >
      <DialogTitle id="alert-dialog-title" sx={{ color: "#d32f2f", fontWeight: "bold" }}>
        Confirm Delete Ticket
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" sx={{ color: "#333333" }}>
          Are you sure you want to delete ticket #{ticketData?.id || "N/A"}: "{ticketData?.subject || "Unknown"}"?
          <br />
          <br />
          <span style={{ color: "#666666", fontSize: "14px" }}>
            This action cannot be undone. The ticket and all associated data will be permanently removed.
          </span>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onClose}
          disabled={deleting}
          sx={{
            color: "#666666",
            "&:hover": {
              backgroundColor: "#f5f5f5",
            },
            "&:disabled": {
              color: "#cccccc",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          disabled={deleting}
          startIcon={deleting ? <CircularProgress size={16} color="inherit" /> : null}
          sx={{
            backgroundColor: "#d32f2f",
            color: "#ffffff",
            "&:hover": {
              backgroundColor: "#b71c1c",
            },
            "&:disabled": {
              backgroundColor: "#cccccc",
              color: "#666666",
            },
          }}
        >
          {deleting ? "Deleting..." : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;